export default {"src":"/_next/static/media/dash-app-logo.cd0bad69.svg","height":82,"width":82};